const _customerly = (function() {
  var configuration = {
    app_id: '511a7847'
  };
  try {
    !(function() {
      var e = window,
        i = document,
        t = 'customerly',
        n = 'queue',
        o = 'load',
        r = 'settings',
        u = (e[t] = e[t] || []);
      if (u.t) {
        return void u.i(
          '[customerly] SDK already initialized. Snippet included twice.'
        );
      }
      u.t = !0;
      u.loaded = !1;
      u.o = ['event', 'attribute', 'update', 'show', 'hide', 'open', 'close'];
      u[n] = [];
      u.i = function(t) {
        e.console && !u.debug && console.error && console.error(t);
      };
      u.u = function(e) {
        return function() {
          var t = Array.prototype.slice.call(arguments);
          return t.unshift(e), u[n].push(t), u;
        };
      };
      u[o] = function(t) {
        u[r] = t || {};
        if (u.loaded) {
          return void u.i(
            '[customerly] SDK already loaded. Use customerly.update to change settings.'
          );
        }
        u.loaded = !0;
        var e = i.createElement('script');
        (e.type = 'text/javascript'),
          (e.async = !0),
          (e.src = 'https://messenger.customerly.io/launcher.js');
        var n = i.getElementsByTagName('script')[0];
        n.parentNode.insertBefore(e, n);
      };
      u.o.forEach(function(t) {
        u[t] = u.u(t);
      });
    })();
  } catch (ex) {
    console.error('Unable  to load Customerly');
  }
  //Merge a `source` object to a `target` recursively
  const merge = (target, source) => {
    //Iterate through `source` properties and if  an `Object`set property to merge of `target` and `source` properties
    for (const key of Object.keys(source)) {
      if (source[key] instanceof Object) {
        Object.assign(source[key], merge(target[key], source[key]));
      }
    }
    //Join `target` and modified `source`
    Object.assign(target || {}, source);
    return target;
  };
  var obj = {
    load: function(newConfiguration) {
      var w = window;
      try {
        //make sure we have an object.
        newConfiguration = newConfiguration || {};
        //merge received config with current config
        configuration = merge(configuration, newConfiguration);
        if (w.customerly) {
          if (typeof w.customerly.load === 'function') {
            w.customerly.load(configuration);
          } else if (typeof w.customerly.update === 'function') {
            w.customerly.update(configuration);
          } else {
            throw 'The load and update methods does not exist.';
          }
        } else {
          throw 'Customerly core not found.';
        }
      } catch (ex) {
        console.error(
          'Something went wrong while trying to update customerly.',
          ex
        );
      }
    },
    event: function(label) {
      var w = window;
      try {
        if (
          label &&
          typeof label === 'string' &&
          w.customerly &&
          typeof w.customerly.event === 'function'
        ) {
          w.customerly.event(label);
        } else {
          throw 'The event method does not exist.';
        }
      } catch (ex) {
        console.error(
          'Something went wrong while trying to send the customerly event.',
          ex
        );
      }
    }
  };
  return obj;
})();
export default _customerly;
